import { useEffect as u } from "react";
import { usePaymentMethod as f } from "./usePaymentMethod.js";
import { PaymentStatusKind as m } from "./paymentStatus.js";
function c(o) {
  const { paymentStatus: t } = f();
  return u(() => {
    var e, i;
    t.kind === m.SUCCEEDED ? (e = o.onSucceeded) == null || e.call(o, t.payment, t.orderId) : t.kind === m.FAILED && ((i = o.onFailed) == null || i.call(o, t.error, t.orderId));
  }, [t.kind]), t;
}
export {
  c as usePaymentResult
};
//# sourceMappingURL=usePaymentResult.js.map
